import React from 'react';
import { Layout } from '../components/Layout';
export function PrivacyPage() {
  return <Layout data-id="element-337">
      <div className="py-24 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-338">
        <div className="max-w-7xl mx-auto" data-id="element-339">
          <h1 className="text-6xl md:text-8xl font-bold mb-8" data-id="element-340">
            Privacy <br data-id="element-341" />
            <span className="italic font-serif font-normal text-espresso" data-id="element-342">
              Policy
            </span>
          </h1>
          <p className="text-xl text-charcoal/60 max-w-2xl leading-relaxed" data-id="element-343">
            Your privacy is important to us. Here is how we handle your data.
          </p>
        </div>
      </div>
      <section className="py-24 px-6 bg-white" data-id="element-344">
        <div className="max-w-4xl mx-auto prose prose-charcoal" data-id="element-345">
          <h2 className="text-3xl font-bold mb-6" data-id="element-346">1. Information Collection</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-347">
            We collect information you provide directly to us, such as when you
            request a quote, schedule a survey, or upload photos of your
            kitchen.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-348">2. Use of Information</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-349">
            We use the information we collect to provide, maintain, and improve
            our services, to communicate with you, and to provide custom quotes.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-350">3. Data Security</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-351">
            We implement reasonable security measures to protect your personal
            information from unauthorized access or disclosure.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-352">4. Third-Party Sharing</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-353">
            We do not sell your personal information to third parties. We may
            share information with service providers who assist us in our
            business operations.
          </p>
        </div>
      </section>
    </Layout>;
}